import React, { useEffect, useState } from 'react';

function ProfileLoggedOut() {
  /**
   * Determines whether the Profile Notification is shown or not.
   * @type {[boolean, function(boolean): void]} showProfileNotification, toggleProfileNotification
   */
  const [showProfileNotifcation, toggleProfileNotification] = useState(false);

  /**
   * Checks if showProfileNotification is set to True in localStorage, and sets the state accordingly.
   * If showProfileNotifcation is not set in localStorage, it is set to True by default.
   * @returns {void}
   */
  useEffect(() => {
    if (window?.config?.feature_oauth2) {
      if (!window?.localStorage?.getItem('showProfileNotification')) {
        window?.localStorage?.setItem('showProfileNotification', 'True');
        toggleProfileNotification(true);
      } else {
        toggleProfileNotification(
          window?.localStorage?.getItem('showProfileNotification') === 'True'
        );
      }
    }
  }, []);

  return (
    <svg
      version="1.1"
      id="Layer_1"
      xmlns="http://www.w3.org/2000/svg"
      xlinkHref="http://www.w3.org/1999/xlink"
      x="0px"
      y="0px"
      viewBox="0 0 200 200"
      className="relative fill-white"
      xmlSpace="preserve"
    >
      <g>
        <g>
          <path d="M100,103.4c-20.5,0-37.2-16.7-37.2-37.2S79.5,29,100,29s37.2,16.7,37.2,37.2S120.5,103.4,100,103.4z M100,38.6 c-15.2,0-27.6, 12.4-27.6,27.6S84.8,93.8,100,93.8s27.6-12.4,27.6-27.6S115.2,38.6,100,38.6z" />
        </g>
        <g>
          <path d="M160.2,171c-2.2,0-4.2-1.5-4.7-3.7l-11.9-42.9H56l-11.9,42.9c-0.6,2.6-3.2,4.2-5.7,3.6c-2.6-0.6-4.2-3.2-3.6-5.7 l12.8-46.6c0.5-2.2,2.4-3.7,4.7-3.7h95.3c2.2,0,4.2,1.5,4.7,3.7l12.8,46.6c0.6,2.6-1,5.1-3.6,5.7C161.1,171,160.6,171,160.2,171z" />
        </g>
        {showProfileNotifcation && (
          <g>
            <rect x="0" y="150" width="50" height="50" rx="25" fill="#9D54D8" />
          </g>
        )}
      </g>
    </svg>
  );
}

export default ProfileLoggedOut;
